import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-adresse',
  templateUrl: './info-adresse.component.html',
  styleUrls: ['./info-adresse.component.scss'],
  standalone: false,
})
export class InfoAdresseComponent {
  @Input() adresse: string;
}
